import { useState } from 'react';
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useForm } from "react-hook-form";
import { get } from "@utils/axios_api";

const fetchHistoryModalList = async (params) => {
  const response = await get("/admin/lectureApply/applyHistory", { params });
  return response;
};

export function useLectureApplyHistoryModal(lectureId) {
  const methods = useForm({
    defaultValues: {
      searchCnd: '',
      searchWrd: '',
      applyStatusNm: '',
    },
    shouldFocusError: false, // Focus 방지
  });

  const [committedSearch, setCommittedSearch] = useState({
    searchCnd: "",
    searchWrd: "",
    applyStatusNm: "",
  });

  const [pageIndex, setPageIndex] = useState(1);
  const recordCountPerPage = 5;

  const { searchCnd, searchWrd, applyStatusNm } = committedSearch;

  

  const { data } = useQuery({
    queryKey: ["selectHistoryModalList", committedSearch, pageIndex, lectureId],
    queryFn: () =>
      fetchHistoryModalList({ searchCnd, searchWrd,applyStatusNm, pageIndex, recordCountPerPage, lectureId }),
      keepPreviousData: true,
  });

  const onSubmit = (values) => {
    setCommittedSearch(values);
    setPageIndex(1);
  };

  const handlePageChange = (targetPage) => {
    setPageIndex(targetPage);
  };

  const resetSearch = () => {
    if (!window.confirm('조회 조건을 초기화 하시겠습니까?')) return;
    setCommittedSearch({ searchCnd: "", searchWrd: "", applyStatusNm: "" });
    setPageIndex(1);
    methods.reset({ searchCnd: "", searchWrd: "", applyStatusNm: "" });
  };


  return {
    methods, data, onSubmit,
    handlePageChange, resetSearch,
    pageIndex, recordCountPerPage, 
  };
}
